import React, { Component } from 'react';
import './RandomNewsSite.css';

class App extends Component {
  constructor(props) {
    super(props);
  }

  componentWillMount() {
    console.log(this.props.headerFont)
    console.log(this.props.bodyFont)
  }

  componentDidUpdate() {
    var a = document.getElementsByClassName("accent-a");
    for (var i = 0, il = a.length; i < il; i++) {
      a[i].style.color = this.props.accentColor;
    }

    var b = document.getElementsByClassName("btn-primary");
    for (var i = 0, il = b.length; i < il; i++) {

      b[i].style.backgroundColor = this.props.accentColor;
      b[i].style.borderColor = this.props.accentColor;
      b[i].style.color = this.props.backgroundColor;
    }

    var b = document.getElementsByClassName("card");
    for (var i = 0, il = b.length; i < il; i++) {

      b[i].style.backgroundColor = this.props.backgroundColor;
    }
  }

  componentDidMount() {
    var a = document.getElementsByClassName("accent-a");
    for (var i = 0, il = a.length; i < il; i++) {
      a[i].style.color = this.props.accentColor;
    }

    var b = document.getElementsByClassName("btn-primary");
    for (var i = 0, il = b.length; i < il; i++) {

      b[i].style.backgroundColor = this.props.accentColor;
      b[i].style.borderColor = this.props.accentColor;
      b[i].style.color = this.props.backgroundColor;
    }

    var b = document.getElementsByClassName("card");
    for (var i = 0, il = b.length; i < il; i++) {

      b[i].style.backgroundColor = this.props.backgroundColor;
    }
  }

  render() {
    return (
      <div
        className="bodywrap"
        style={{
          backgroundColor: this.props.backgroundColor,
          color: this.props.baseColor,
          fontFamily: this.props.bodyFont,
        }}
      >
        <link rel="stylesheet" type="text/css" href={'https://fonts.googleapis.com/css?family=' + this.props.headerFont} />
        <link rel="stylesheet" type="text/css" href={'https://fonts.googleapis.com/css?family=' + this.props.bodyFont} />
        <nav class="navbar navbar-expand-lg navbar-dark bg-dark fixed-top">
          <div class="container">
            <a class="navbar-brand" href="#" style={{ fontFamily: this.props.headerFont }}>Generic News Site</a>
            <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarResponsive" aria-controls="navbarResponsive" aria-expanded="false" aria-label="Toggle navigation">
              <span class="navbar-toggler-icon"></span>
            </button>
            <div class="collapse navbar-collapse" id="navbarResponsive">
              <ul class="navbar-nav ml-auto">
                <li class="nav-item active">
                  <a class="nav-link" href="#">Home
                <span class="sr-only">(current)</span>
                  </a>
                </li>
                <li class="nav-item">
                  <a class="nav-link" href="#">About</a>
                </li>
                <li class="nav-item">
                  <a class="nav-link" href="#">Services</a>
                </li>
                <li class="nav-item">
                  <a class="nav-link" href="#">Contact</a>
                </li>
              </ul>
            </div>
          </div>
        </nav>

        <div className="bodyhelper"></div>
        <div class="container">

          <div class="row">


            <div class="col-md-8">
              <div class="card mb-4 my-4">
                <img class="card-img-top" src={this.props.imageUrl} alt="Card image cap" />
                <div class="card-body">
                  <h2 class="card-title" style={{ fontFamily: this.props.headerFont }}>Post Title</h2>
                  <p class="card-text">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Reiciendis aliquid atque, nulla? Quos cum ex quis soluta, a laboriosam. Dicta expedita corporis animi vero voluptate voluptatibus possimus, veniam magni quis!</p>
                  <a href="#" class="btn btn-primary">Read More &rarr;</a>
                </div>
              </div>


              <div class="card mb-4">
                <img class="card-img-top" src={this.props.imageUrl} alt="Card image cap" />
                <div class="card-body">
                  <h2 class="card-title" style={{ fontFamily: this.props.headerFont }}>Post Title</h2>
                  <p class="card-text">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Reiciendis aliquid atque, nulla? Quos cum ex quis soluta, a laboriosam. Dicta expedita corporis animi vero voluptate voluptatibus possimus, veniam magni quis!</p>
                  <a href="#" class="btn btn-primary">Read More &rarr;</a>
                </div>
              </div>


              <div class="card mb-4">
                <img class="card-img-top" src={this.props.imageUrl} alt="Card image cap" />
                <div class="card-body">
                  <h2 class="card-title" style={{ fontFamily: this.props.headerFont }}>Post Title</h2>
                  <p class="card-text">Lorem ipsum dolor sit amet, consectetur adipisicing elit. Reiciendis aliquid atque, nulla? Quos cum ex quis soluta, a laboriosam. Dicta expedita corporis animi vero voluptate voluptatibus possimus, veniam magni quis!</p>
                  <a href="#" class="btn btn-primary">Read More &rarr;</a>
                </div>
              </div>


              <ul class="pagination justify-content-center mb-4">
                <li class="page-item">
                  <a class="page-link" href="#">&larr; Older</a>
                </li>
                <li class="page-item disabled">
                  <a class="page-link" href="#">Newer &rarr;</a>
                </li>
              </ul>

            </div>


            <div class="col-md-4">


              <div class="card my-4">
                <h5 class="card-header" style={{ fontFamily: this.props.headerFont }}>Search</h5>
                <div class="card-body">
                  <div class="input-group">
                    <input type="text" class="form-control" placeholder="Search for..." />
                    <span class="input-group-btn">
                      <button class="btn btn-secondary" type="button">Go!</button>
                    </span>
                  </div>
                </div>
              </div>


              <div class="card my-4">
                <h5 class="card-header" style={{ fontFamily: this.props.headerFont }}>Categories</h5>
                <div class="card-body">
                  <div class="row">
                    <div class="col-lg-6">
                      <ul class="list-unstyled mb-0">
                        <li>
                          <a href="#" className="accent-a">Web Design</a>
                        </li>
                        <li>
                          <a href="#" className="accent-a">HTML</a>
                        </li>
                        <li>
                          <a href="#" className="accent-a">Freebies</a>
                        </li>
                      </ul>
                    </div>
                    <div class="col-lg-6">
                      <ul class="list-unstyled mb-0">
                        <li>
                          <a href="#" className="accent-a">JavaScript</a>
                        </li>
                        <li>
                          <a href="#" className="accent-a">CSS</a>
                        </li>
                        <li>
                          <a href="#" className="accent-a">Tutorials</a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>


              <div class="card my-4">
                <h5 class="card-header" style={{ fontFamily: this.props.headerFont }}>Side Widget</h5>
                <div class="card-body">
                  You can put anything you want inside of these side widgets. They are easy to use, and feature the new Bootstrap 4 card containers!
            </div>
              </div>

            </div>

          </div>


        </div>



        <footer class="py-5 bg-dark">
          <div class="container">
            <p class="m-0 text-center text-white">Other information here</p>
          </div>

        </footer>

      </div >

    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/RandomNewsSite.js